//Create redux slice for advisorProfile
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { advisorService } from './advisor.service';
import { setAlertError, setAlertSuccess } from '../alert/alert.slice';

const initialState = {
  advisors: [],
  providers: [],
  loadingAdvisors: false,
  loadingCodes: false,
  addingCode: false,
  loading: false,
  client: {
    client: null,
    account: null,
    fetchingClient: false,
    fetchingBalances: false
  }
};

export const addAdvisor = createAsyncThunk('advisor/addAdvisor', async (data, thunkAPI) => {
  return await advisorService
    .addAdvisor(data)
    .then((response) => {
      thunkAPI.dispatch(setAlertSuccess('Advisor added successfully'));
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const inviteAdvisor = createAsyncThunk('advisor/inviteAdvisor', async (id, thunkAPI) => {
  try {
    const response = await advisorService.inviteAdvisor(id);
    thunkAPI.dispatch(setAlertSuccess('Invitation sent successfully'));
    return response;
  } catch (error) {
    const err = error.response?.data || { message: 'Failed to send invitation' };
    thunkAPI.dispatch(setAlertError(err.message));
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const getCodes = createAsyncThunk('advisor/getCodes', async (userId, thunkAPI) => {
  return await advisorService
    .getCodes(userId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const getAdvisors = createAsyncThunk('advisor/getAdvisors', async (_, thunkAPI) => {
  return await advisorService
    .getAdvisors()
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response?.data;
      thunkAPI.dispatch(setAlertError(err?.message || 'Failed to fetch advisors.'));
      return thunkAPI.rejectWithValue(err?.message || 'Failed to fetch advisors.');
    });
});

export const updateAdvisor = createAsyncThunk('advisor/updateAdvisor', async (data, thunkAPI) => {
  return await advisorService
    .updateAdvisor(data)
    .then((response) => {
      thunkAPI.dispatch(setAlertSuccess('Advisor updated successfully'));
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const mappAdvisorCode = createAsyncThunk(
  'advisor/mappAdvisorCode',
  async (data, thunkAPI) => {
    return await advisorService
      .mappAdvisorCode(data)
      .then((response) => {
        thunkAPI.dispatch(setAlertSuccess('Advisor code mappeed successfully'));
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err.message));
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);
export const removeAdvisorCode = createAsyncThunk(
  'advisor/removeAdvisorCode',
  async (data, thunkAPI) => {
    return await advisorService
      .removeAdvisorCode(data)
      .then((response) => {
        thunkAPI.dispatch(setAlertSuccess('Advisor code mappeed successfully'));
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err.message));
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const deleteAdvisor = createAsyncThunk('advisor/deleteAdvisor', async (id, thunkAPI) => {
  return await advisorService
    .deleteAdvisor(id)
    .then((response) => {
      thunkAPI.dispatch(setAlertSuccess('Advisor deleted successfully'));
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const addCode = createAsyncThunk('advisor/addCode', async (data, thunkAPI) => {
  return await advisorService
    .addCode(data)
    .then((response) => {
      thunkAPI.dispatch(setAlertSuccess('Code added successfully'));
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const removeCode = createAsyncThunk('advisor/removeCode', async (id, thunkAPI) => {
  return await advisorService
    .removeCode(id)
    .then((response) => {
      thunkAPI.dispatch(setAlertSuccess('Code removed successfully'));
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const getProviders = createAsyncThunk('advisor/getProviders', async (userId, thunkAPI) => {
  return await advisorService
    .getProviders(userId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const getClientById = createAsyncThunk('advisor/getClientById', async (id, thunkAPI) => {
  return await advisorService
    .getClientById(id)
    .then((response) => {
      console.log(response);
      thunkAPI.dispatch(setAlertSuccess('Client fetched successfully'));
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const getClientBalances = createAsyncThunk(
  'advisor/getClientBalances',
  async (id, thunkAPI) => {
    return await advisorService
      .getClientBalances(id)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err.message));
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const advisorSlice = createSlice({
  name: 'advisor',
  initialState,
  reducers: {
    clearClient: (state) => {
      state.client = {
        client: null,
        account: null,
        fetchingClient: false,
        fetchingBalances: false
      };
    }
  },
  extraReducers: {
    [addAdvisor.fulfilled]: (state, action) => {
      state.loading = false;
      state.advisors.push(action.payload);
    },
    [addAdvisor.pending]: (state) => {
      state.loading = true;
    },
    [addAdvisor.rejected]: (state) => {
      state.loading = false;
    },

    [getAdvisors.pending]: (state) => {
      state.loadingAdvisors = true;
    },
    [getAdvisors.fulfilled]: (state, action) => {
      state.advisors = action.payload.advisors;
      state.loadingAdvisors = false;
    },
    [getAdvisors.rejected]: (state) => {
      state.loadingAdvisors = false;
    },
    [getCodes.fulfilled]: (state, action) => {
      state.codes = action.payload.codes;
      state.loadingCodes = false;
    },
    [getCodes.pending]: (state) => {
      state.loadingCodes = true;
    },
    [getCodes.rejected]: (state) => {
      state.loadingCodes = false;
    },
    [addCode.rejected]: (state) => {
      state.addingCode = false;
    },
    [addCode.fulfilled]: (state, action) => {
      state.addingCode = false;
      state.codes = action.payload.codes;
    },
    [addCode.pending]: (state) => {
      state.addingCode = true;
    },
    [removeCode.fulfilled]: (state, action) => {
      state.codes = action.payload.codes;
      state.loadingCodes = false;
    },
    [removeCode.pending]: (state) => {
      state.loadingCodes = true;
    },
    [removeCode.rejected]: (state) => {
      state.loadingCodes = false;
    },
    [getProviders.fulfilled]: (state, action) => {
      state.providers = action.payload.providers;
      state.loading = false;
    },
    [getProviders.pending]: (state) => {
      state.loading = true;
    },
    [getProviders.rejected]: (state) => {
      state.loading = false;
    },
    [updateAdvisor.pending]: (state) => {
      state.loading = true;
    },
    [updateAdvisor.fulfilled]: (state, action) => {
      state.loading = false;
      const index = state.advisors.findIndex((advisor) => advisor.id === action.payload.id);
      if (index !== -1) {
        state.advisors[index] = action.payload;
      }
    },
    [updateAdvisor.rejected]: (state) => {
      state.loading = false;
    },
    [mappAdvisorCode.pending]: (state) => {
      state.loading = true;
    },
    [mappAdvisorCode.fulfilled]: (state, action) => {
      state.loading = false;
      const index = state.advisors.findIndex((advisor) => advisor.id === action.payload.id);
      if (index !== -1) {
        state.advisors[index] = action.payload;
      }
    },
    [mappAdvisorCode.rejected]: (state) => {
      state.loading = false;
    },
    [removeAdvisorCode.pending]: (state) => {
      state.loading = true;
    },
    [removeAdvisorCode.fulfilled]: (state, action) => {
      state.loading = false;
      const index = state.advisors.findIndex((advisor) => advisor.id === action.payload.id);
      if (index !== -1) {
        state.advisors[index] = action.payload;
      }
    },
    [removeAdvisorCode.rejected]: (state) => {
      state.loading = false;
    },
    [deleteAdvisor.pending]: (state) => {
      state.loading = true;
    },
    [deleteAdvisor.fulfilled]: (state, action) => {
      state.loading = false;
      state.advisors = state.advisors.filter((advisor) => advisor._id !== action.payload._id);
    },
    [deleteAdvisor.rejected]: (state) => {
      state.loading = false;
    },
    [getClientById.pending]: (state) => {
      state.client.fetchingClient = true;
    },
    [getClientById.fulfilled]: (state, action) => {
      state.client.client = action.payload.client;
      state.client.fetchingClient = false;
    },
    [getClientById.rejected]: (state) => {
      state.client.fetchingClient = false;
    },
    [getClientBalances.pending]: (state) => {
      state.client.fetchingBalances = true;
    },
    [getClientBalances.fulfilled]: (state, action) => {
      state.client.account = action.payload;
      state.client.fetchingBalances = false;
    },
    [getClientBalances.rejected]: (state) => {
      state.client.fetchingBalances = false;
    },
    [inviteAdvisor.pending]: (state) => {
      state.loading = true;
    },
    [inviteAdvisor.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [inviteAdvisor.rejected]: (state) => {
      state.loading = false;
    }
  }
});

export const { clearClient } = advisorSlice.actions;

export default advisorSlice.reducer;
